// Errors thrown by axios (as of 0.21.4, which is used by @wix/http-client)
// have not so useful stack traces.
// https://github.com/axios/axios/issues/2387
export default function validateHttpResponse(response) {
    if (response.status >= 400) {
        const data = JSON.stringify(response.data);
        const error = new Error(`Request failed with status code ${response.status}. Data: '${data}'.`);
        error.response = response;
        error.config = response.config;
        error.request = response.request;
        throw error;
    }
    return response;
}
//# sourceMappingURL=http-client-utils.js.map